import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Page1 from "./App";
import Page2 from "./ScanWristband";
import Page3 from "./GenerateQrCode";
import Page4 from "./SeeInstruction";
import Page5 from "./AddMoney";

if (!Object.entries) {
  Object.entries = function (object) {
    var ownProps = Object.keys(object),
      i = ownProps.length,
      resArray = new Array(i);
    while (i--) resArray[i] = [ownProps[i], object[ownProps[i]]];
    return resArray;
  };
}

ReactDOM.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Page1} />
      <Route exact path="/page1" component={Page1} />
      <Route path="/page2" component={Page2} />
      <Route path="/page3" component={Page3} />
      <Route path="/page4" component={Page4} />
      <Route path="/page5" component={Page5} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
